module.exports = "table .cke_show_border { border: #d3d3d3 0px dotted !important;}"